import {GridCellKind} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridCellKind';
import {IGridCell} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';

export class TextCell implements IGridCell
{
    constructor(public readonly text:string)
    {}

    getKind():GridCellKind
    {
        return GridCellKind.Text;
    }

    isEqualTo(other:IGridCell): boolean
    {
        return other &&
            other.getKind() === this.getKind() &&
            (other as TextCell).text === this.text;
    }

    toString():string
    {
        return `${this.text}`;
    }
}
